module.exports = __webpack_public_path__ + "img/272.9d58d48a.png";